import { createSelector } from '@reduxjs/toolkit';

import { getRelationshipDomainsAndRanges } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/getRelationshipDomainsAndRanges';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';

export const projectRelationshipDomainAndRangesSelector = (
  projectId: string,
  relationshipIri: string
) =>
  createSelector(projectLinkDataArraySelector(projectId), (linkDataArray) =>
    getRelationshipDomainsAndRanges(linkDataArray, relationshipIri)
  );
